import { FieldBackground, FieldBorder, FieldColor, FieldTheme } from 'framework/field/types';

import { colors, font } from '../theme/constants/colors';
import { font_theme } from '../theme/constants/font';

export const field_theme: Pick<FieldTheme, 'general'> = {
  general: {
    icon_width: '30px',
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    line_height: '13px',
    placeholder: colors.light[6],
    padding: '0px 8px',
    border_radius: '4px',
  },
};

export const field_color_theme: FieldColor = {
  normal: font.dark.normal,
  hover: colors.purple[8],
  focus: colors.purple[9],
  active: colors.purple[8],
  disabled: colors.light[5],
  error: colors.red[6],
};

export const field_background_theme: FieldBackground = {
  normal: colors.dark[10],
  hover: colors.dark[11],
  focus: colors.dark[10],
  active: colors.dark[10],
  disabled: colors.dark[10],
  error: colors.red[10],
};

export const field_border_color = colors.dark[7];
export const field_border_theme: FieldBorder = {
  normal: `1px solid ${field_border_color}`,
  hover: `1px solid ${colors.purple[8]}`,
  focus: `1px solid ${colors.purple[8]}`,
  active: `1px solid ${colors.purple[9]}`,
  disabled: `1px solid ${colors.dark[7]}`,
  error: `1px solid ${colors.red[6]}`,
};

export const field_dark_theme: FieldTheme = {
  general: field_theme.general,
  background: field_background_theme,
  border: field_border_theme,
  color: field_color_theme,
};
